import React, { useState, useEffect } from 'react';
import TermsAndConditionsEditor from '../components/TermsAndConditionsEditor';
import Helper from '../helpers';

const VenueTermsManagement = () => {
    const [venueId, setVenueId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchVenueId = async () => {
            try {
                const id = await Helper.getUserVenueId();
                setVenueId(id);
            } catch (error) {
                console.error('Error fetching venue ID:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchVenueId();
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-luxury-pearl">Loading...</div>
            </div>
        );
    }

    if (!venueId) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="card-luxury p-8 text-center">
                    <h2 className="text-2xl font-display font-bold text-luxury-pearl mb-4">
                        No Venue Found
                    </h2>
                    <p className="text-luxury-pearl/60">
                        Unable to load venue information. Please try again later.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 sm:p-6">
            <div className="max-w-5xl mx-auto">
                <div className="mb-6">
                    <h1 className="text-3xl font-display font-bold text-gradient-emerald mb-2">
                        Venue Terms & Conditions
                    </h1>
                    <p className="text-luxury-pearl/60">
                        Manage your venue's terms and conditions that users will see during signup.
                    </p>
                </div>
                
                <div className="card-luxury p-6">
                    <div className="mb-4 p-4 bg-emerald-600/10 border border-emerald-600/30 rounded-lg">
                        <p className="text-emerald-300 text-sm">
                            <strong>Important:</strong> These terms and conditions will be displayed to users when they sign up for your venue. 
                            Make sure to include all necessary information about your services, policies, and user responsibilities.
                        </p>
                    </div>
                    
                    <TermsAndConditionsEditor venueId={venueId} />
                </div>
            </div>
        </div>
    );
};

export default VenueTermsManagement;
